import { Content } from 'src/contexts/ContentContext';
import { useOffices } from 'src/hooks/api/useOffices';
import { ContentId } from 'src/utils/constants/contentId';

export const OfficeDisplay = ({
  officeId,
}: {
  officeId: number | null | undefined;
}) => {
  const { getOfficeName, isOfficeEnabled } = useOffices();

  if (!isOfficeEnabled || officeId == null) {
    return null;
  }

  const officeName = getOfficeName(officeId);

  if (!officeName) {
    return null;
  }

  return (
    <span>
      <Content id={ContentId.Office} />: {officeName}
    </span>
  );
};
